/**
 * sorts an array of objects alphabetically by a given field
 * @param {Array} a - The first object to compare
 * @param {Array} b - The second object to compare
 * @param {String} field - The field to sort by
 * @returns {Number} - A number indicating the sort order
 */

const sortAlphabetically = (a, b, field) => {
  const textA = a[field].toUpperCase()
  const textB = b[field].toUpperCase()

  if (textA < textB) {
    return -1
  } else if (textA > textB) {
    return 1
  }

  return 0
}

export { sortAlphabetically }
